import { combineReducers } from "redux";
import {
  GET_CREDENTIAL_LIST,
  GET_CREDENTIAL_LIST_OK,
  GET_CREDENTIAL_LIST_ERR,
  DO_CREDENTIAL_LIST_CLEANUP,

  DELETE_CREDENTIAL_LIST_ITEM,
  DELETE_CREDENTIAL_LIST_ITEM_OK,
  DELETE_CREDENTIAL_LIST_ITEM_ERR,

  UPLOAD_CREDENTIAL,
  UPLOAD_CREDENTIAL_OK,
  UPLOAD_CREDENTIAL_ERR,
  DO_CREDENTIAL_FORM_CLEANUP,
} from "./actionTypes";
import {
  getCredentialListOk,
} from "./actions";
import Credential from "~/model/notaryCredential";
import { TFormState, TListState } from "./types";
import { TAction } from "~/types/global";


/********** LIST **********/
const defaultListState: TListState = {
  credentialIds: [],
  credentials: {},
  noOfExpiredCredentials: 0,
  commissionCertificate: 0,
  eoInsurance: 0,
  driverLicense: 0,
  credentialsError: null,
  isLoadInProgress: false,
};

const List = (state = defaultListState, action: TAction) => {
  switch (action.type) {
    // get list
    case GET_CREDENTIAL_LIST:
      state = {
        ...state,
        credentialsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_CREDENTIAL_LIST_OK: {
      const getAction = action as ReturnType<typeof getCredentialListOk>;
      const raw = getAction.payload.response as any;
      const credentials = Array.isArray(raw) ? raw : (Array.isArray(raw.credentials) ? raw.credentials : []);
      const ids: number[] = [];
      const docs = credentials.reduce((prev: Record<number, any>, curr: any) => {
        ids.push(curr.id);
        return { ...prev, [curr.id]: curr };
      }, {} as Record<number, any>);

      // mandatory documents count
      const commissionCertificate = credentials.filter((doc: any) => doc.type === Credential.TYPE_COMMISSION_CERTIFICATE).length;
      const eoInsurance = credentials.filter((doc: any) => doc.type === Credential.TYPE_EO_INSURANCE).length;
      const driverLicense = credentials.filter((doc: any) => doc.type === Credential.TYPE_DRIVER_LICENSE_NUMBER).length;
      const noOfExpiredCredentials = raw.noOfExpiredCredentials ?? 0;

      state = {
        ...state,
        credentialIds: ids,
        credentials: docs,
        noOfExpiredCredentials,
        commissionCertificate,
        eoInsurance,
        driverLicense,
        credentialsError: null,
        isLoadInProgress: false,
      };
      break
    }
    case GET_CREDENTIAL_LIST_ERR: {
      state = {
        ...state,
        credentialIds: [],
        credentials: {},
        noOfExpiredCredentials: 0,
        credentialsError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    }
    // delete doc
    case DELETE_CREDENTIAL_LIST_ITEM: {
      const docId = action.payload.id;
      const doc = state.credentials[docId];
      if (doc) {
        state = {
          ...state,
          credentials: {
            ...state.credentials,
            [docId]: {
              ...doc,
              isDeleted: null,
              isDeleteInProgress: true,
              deleteError: null,
            },
          },
        };
      }
      break;
    }
    case DELETE_CREDENTIAL_LIST_ITEM_OK: {
      const docId = action.payload.id;
      const doc = state.credentials[docId];
      if (doc) {
        state = {
          ...state,
          credentials: {
            ...state.credentials,
            [docId]: {
              ...doc,
              isDeleted: true,
              isDeleteInProgress: false,
            },
          },
        };
      }
      break;
    }
    case DELETE_CREDENTIAL_LIST_ITEM_ERR: {
      const docId = action.payload.id;
      const doc = state.credentials[docId];
      if (doc) {
        state = {
          ...state,
          credentials: {
            ...state.credentials,
            [docId]: {
              ...doc,
              isDeleted: false,
              isDeleteInProgress: false,
              deleteError: action.payload.error,
            },
          },
        };
      }
      break;
    }
    // cleanup
    case DO_CREDENTIAL_LIST_CLEANUP:
      state = { ...defaultListState };
      break
  }
  return state;
}

/********** FORM **********/

const defaultFormState: TFormState = {
  doc: null,
  uploaded: null,
  uploadError: null,
  isUploadInProgress: false,
}

const Form = (state = defaultFormState, action: TAction) => {
  switch (action.type) {
    case UPLOAD_CREDENTIAL:
      state = {
        ...state,
        uploaded: null,
        uploadError: null,
        isUploadInProgress: true,
      };
      break
    case UPLOAD_CREDENTIAL_OK: {
      state = {
        ...state,
        doc: {
          ...state.doc,
          id: action.payload.response.id,
        },
        uploaded: true,
        isUploadInProgress: false,
      };
      break
    }
    case UPLOAD_CREDENTIAL_ERR: {
      state = {
        ...state,
        uploaded: false,
        uploadError: action.payload.error,
        isUploadInProgress: false,
      };
      break
    }
    case DO_CREDENTIAL_FORM_CLEANUP:
      state = { ...defaultFormState };
      break
  }
  return state;
}

export default combineReducers({
  List,
  Form,
});